import { RenderableErrorResponse } from '../../../../../services/exports/Types';
import { useSelector } from 'react-redux';
import { companiesApiSlice } from '../../../../../store/api-slices';
import { store } from '../../../../../store';
import { selectCompanyId } from '../../../../../store/slices/InitialDataSlice';

const useItemsUnavailableErrorHandler = () => {
  const companyId = useSelector(selectCompanyId);
  const handler = (response: RenderableErrorResponse<number[]>): void => {
    const productIds = response.response.data.payload;

    store.dispatch(
      companiesApiSlice.util.updateQueryData('getCompanyMenusData', companyId, (draft) => {
        productIds.forEach((productId) => {
          draft.products[productId].is_available = false;
        });
      }),
    );
  };

  return handler;
};

export default useItemsUnavailableErrorHandler;
